import Compressor from "compressorjs";

// 使用压缩
export function useCompressor(base64, option = {}) {
  let opts = Object.assign(
    {
      strict: true,
      checkOrientation: true,
      retainExif: false,
      maxWidth: undefined,
      maxHeight: undefined,
      minWidth: 0,
      minHeight: 0,
      width: undefined,
      height: undefined,
      resize: "none",
      quality: 0.8,
      mimeType: "",
      convertTypes: "image/png",
      convertSize: 5000000,
    },
    option
  );
  function base64toBlob(dataurl) {
    //base64转blob
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  let fileBlob = base64toBlob(base64);
  new Compressor(fileBlob, opts);
}

// blob 转base64
export function useBlobToBase64(blob, fileName, mimeType) {
  return new File([blob], fileName, { type: mimeType });
}
